import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">Contacts</h1>
      <p>If you have any questions relating to the MyScan service or would like to check if you can use Hull MyScan for your claim, please contact Hull City Council.</p>
      <p>You can contact Hull City Council on:</p>
      <p><strong>01482 300 300</strong></p>
      <p><strong>Normal Opening Hours</strong></p>
      <p>Monday to Saturday, 9am - 5pm</p>

    </React.Fragment>
  );
}
